import { isEmpty } from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export const needsToFetchData = substate => !substate || !substate.data || isEmpty(substate.data);
